module.exports = ".fixed-quote-box-shadow {\n  box-shadow: 0 0 10px #d7d7d7;\n  overflow: hidden;\n  padding: 45px 15px 0;\n  margin-bottom: -10px;\n  position: relative; }\n  .fixed-quote-box-shadow:after {\n    content: '';\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    display: block;\n    height: 20px;\n    width: 100%;\n    z-index: 10;\n    background-color: #fff; }\n"


//////////////////
// WEBPACK FOOTER
// ./web/modern/components/quote/quote-view-fixed/quote-view-fixed.scss
// module id = ./web/modern/components/quote/quote-view-fixed/quote-view-fixed.scss
// module chunks = 0